export const en = {
    lang: 'en',
    /* Language selection */
    lang_title: "Choose language",
    /* Dates */
    dates_day_ago: "days ago",
    dates_day_now: "today",
    dates_day_sun: "sun",
    dates_day_mon: "mon",
    dates_day_tue: "tue",
    dates_day_wed: "wed",
    dates_day_thu: "thu",
    dates_day_fri: "fri",
    dates_day_sat: "sat",
    dates_month_1: "January",
    dates_month_2: "February",
    dates_month_3: "March",
    dates_month_4: "April",
    dates_month_5: "May",
    dates_month_6: "June",
    dates_month_7: "July",
    dates_month_8: "August",
    dates_month_9: "September",
    dates_month_10: "October",
    dates_month_11: "November",
    dates_month_12: "December",
    dates_month_pril_1: "January",
    dates_month_pril_2: "February",
    dates_month_pril_3: "March",
    dates_month_pril_4: "April",
    dates_month_pril_5: "May",
    dates_month_pril_6: "June",
    dates_month_pril_7: "July",
    dates_month_pril_8: "August",
    dates_month_pril_9: "September",
    dates_month_pril_10: "October",
    dates_month_pril_11: "November",
    dates_month_pril_12: "December",
    /* LoginPage */
    //Login 
    login_alert_user_exist: "A user with this email exists.",
    login_alert_user_miss: "User is not found",
    login_alert_wrong_filling: "Fill in the username or password",
    login_alert_pass_send: "Password has been sent to your email",
    login_alert_server_not_available: "Server is temporarily unavailable",
    login_alert_fill_fields: "Please fill in all the lines",
    login_alert_fill_name: "Fill in the name field",
    login_alert_fill_lastname: "Fill in the last name field",
    login_alert_fill_email: "Fill in the email field",
    login_alert_fill_street: "Fill in the street",
    login_alert_fill_city: "Fill in the city field",
    login_alert_fill_password: "Fill in the password field",
    login_alert_fill_code: "The index field is empty",

    //alert message end
    login_enter_profile: "Login to profile",
    login_reg: "Sign up",
    login_enter: "Log in",
    login_my_order: "My order",
    login_btn_facebook_enter: "Log in using facebook",
    login_or: "or",
    login_email: "E-mail",
    login_pass: "Password",
    login_enter_email: "Login with your Е-mail",
    login_forgot_pass: "Forgot your password?",
    login_btn_reg: "Registration",
    login_btn_entered: "Log in",
    login_btn_cancel: "Cancel",
    login_btn_pass_send: "Send password",
    // Registration
    reg_user_reg: "User registration",
    reg_individual_face: "Individual",
    reg_entity_face: "Legal entity",
    reg_second_name: "Surname",
    reg_name: "Name",
    reg_organization_name: "Name of the company:",
    reg_INN: "Company Registration No.:",
    reg_entity_adress: "Legal address:",
    reg_email: "E-mail:",
    reg_pass: "Password:",
    reg_again_pass: "Confirm password:",
    reg_again_pass_wrong: "* Password mismatch",
    reg_question_about_find: "How did you hear about us?",
    reg_inet_AD: "Internet advertising",
    reg_recommend: "Recommendation",
    reg_over: "Other",
    reg_delivery_info: "Delivery information",
    reg_info_task: "To place an order, you need to add delivery information.",
    reg_phone: "Contact number:",
    reg_delivery_data: "The date of the first delivery:",
    reg_street: "Street, house:",
    reg_city: "Town:",
    reg_index: "Postal code:",
    reg_commentary: "Comment:",
    reg_dop_info: "Additional delivery information (apartment number, other comment for the courier)",
    reg_agreement_1: "By clicking the Registration button, you confirm ",
    reg_agreement_2: "Processing of personal date agreement",
    reg_agreement_3: "Terms of use",

    reg_exclude_1: "Meat",
    reg_exclude_2: "Fish and Seafood",
    reg_exclude_2: "Nuts",
    reg_exclude_3: "Dairy (lactose free)",
    reg_exclude_4: "Strawberry",
    reg_exclude_5: "Mushrooms",
    reg_exclude_6: "Other",
    reg_exclude_text: "Exclude from diet",
    reg_exclude_text2: "No exclusion",

    reg_exclude_about: "* Replacement of one product - free of charge, replacement of each subsequent product - 20 CZK / one product per day. Replacement of dairy products - 40 CZK per day.</br> If you chose a product which was not mentioned in the list, then the possibility of excluding it will be confirmed by the manager after receiving the order.</br> The replacement cost will be added to the program price after the order is confirmed by our manager. The final invoice will be sent within 2 business days.",

    reg_btn_reg: "Registration",
    reg_btn_cancel: "Back",
    reg_and: "and",
    /* BonusPage */
    bonus_alert_copyed: "Copied",
    bonus_header_1: "Profile iKitchen",
    bonus_header_2: "Bonuses",
    bonus_my_bonus: "My bonuses:",
    bonus_barter: "1 bonus = 1 CZK",
    bonus_rule_0: "Bonus Spend Rules",
    bonus_rule_1: "You cannot create fake accounts",
    bonus_rule_2: "You can pay with bonuses no more than 20% of the total order.",
    bonus_rule_3: "This percentage may vary, depending on the rules of a particular marketing campaign.",
    bonus_rule_4: "Share the promo code with your friends and get bonuses!",
    bonus_promocode: "Copy the promo code from here:",
    bonus_btn_promocode: "Copy promo code",
    bonus_promocode_rule: "The validity period of this promo code is 30 days",
    bonus_info: "Affiliate program rules information",
    bonus_info_cashback: "Cashback:",
    bonus_info_text1: "From ordering a menu for two days / week / month there is a cashback to the account in the form of iKitchen bonuses, as a percentage of the price (2%)",
    bonus_info_promocode: "Promo code:",
    bonus_info_text2: "A promotional code will be generated that can be given to acquaintances and friends. After friends make and pay for their order with a promotional code, a percentage of the order comes to your account. At the same time, the amount is credited to the person who made the order and paid for it.",
    /* CartPage */
    cart_alert_error: "Error processing the order",
    cart_basket: "Basket iKitchen",
    cart_new_order: "My basket",
    cart_dont_paid: "Unpaid",
    cart_on_day1: "on",
    cart_on_day2: "days",
    cart_to_paid: "Payable",
    cart_btn_paid: "Confirm order",
    cart_btn_paid2: "Online payment",
    cart_currency: "CZK",
    cart_btn_cancel_order: "Remove from basket",
    cart_info: "on marked days, you can further customize the menu.",
    cart_menu: "Menu",
    cart_delivery: "Delivery",
    cart_summary_in: "Total in",
    cart_kkal: "kCal",
    cart_B: "Protein",
    cart_J: "Fat",
    cart_U: "Carbs",
    cart_drink: "drink",
    cart_gramm: "g",
    cart_breakfast: " Breakfast",
    cart_delivery_data: "Date of the first delivery",
    cart_delivery_info_1: "Delivery is carried out on Sunday, Tuesday and Thursday with a meal plan for 2 days.",
    cart_delivery_info_2: "Start of program from Monday - order until Friday",
    cart_delivery_info_3: "Start of program from Wednesday - order before Sunday",
    cart_delivery_info_4: "Start of program from Friday - order until Tuesday",
    cart_delivery_from_day: "Daily Delivery",
    cart_delivery_info_5: "Photos of dishes on the site are an option for serving dishes. The appearance of the dish may differ from the photos on the site. We reserve the right to change some ingredients depending on their availability",
    cart_empty_backet: "You have an empty basket yet",
    cart_btn_go_to_menu: "Go to the menu",
    /* HomePage */
    home_kkal: "kCal",
    home_currency: "CZK",
    /* About */
    home_about_header_1: "Healthy and tasty food",
    home_about_header_2: "delivery of ready meal plans for each day",
    home_about_text_1: "Tasty like in a restaurant",
    home_about_text_2: "Food cooked by premium professional chefs in cooperation with nutritionists",
    home_about_text_3: "Balanced diet",
    home_about_text_4: "Menu is created according to the optimal proportion of Cal,Pro, Fat, Carbs. You don’t have to buy products - you'll get everything including fruits and healthy desserts",
    home_about_text_5: "A new menu every day",
    home_about_text_6: "Dishes do not repeat during one month period ",
    home_about_text_7: "A variety of programs for everyone",
    home_about_text_8: "Balance, Vege, Keto, Anti-age.",
    home_about_text_9: "Modern production ",
    home_about_text_10: "Intelligent equipment for the best result. HACCP certified",
    home_about_text_11: "Comfortable delivery",
    home_about_text_12: "Delivery to the door by polite couriers",
    home_about_text_13: "Bonus system",
    home_about_text_14: "Discount system, bonuses and cashbacks ",
    home_about_text_15: "My account",
    home_about_text_16: "Convenient personal account of the client and mobile application",
    /* Calculate */
    home_calculate_header_1: "Choose ",
    home_calculate_header_2: "right plan",
    home_calculate_subtitle: "Meal plan for you",
    home_calculate_btn: "To selected menu ",
    /* Food Menu */
    home_food_menu_header_1: "Balanced Plans",
    home_food_menu_header_2: "Your meal plan ready",
    home_food_menu_in: "Indredients",
    home_food_menu_day: "Day of the week",
    home_food_menu_text_0: "MONDAY",
    home_food_menu_text_1: "Meal",
    home_food_menu_text_2: "BREAKFAST",
    home_food_menu_text_3: "Breakfast",
    home_food_menu_text_4: "Snack",
    home_food_menu_text_5: "Lunch",
    home_food_menu_text_6: "Dessert",
    home_food_menu_text_7: "Dinner",
    home_food_menu_option_stop: "Pause plan",

    home_food_menu_option_1: "Program Length",
     home_food_menu_option_2: "Setting portions",
     home_food_menu_option_3: "Number of people",
     home_food_menu_option_4: "Length of week",
     home_food_menu_option_4_item_1: "Mon - Sat",
     home_food_menu_option_4_item_2: "Mon - Fri",
     home_food_menu_option_5: "Payment",
     home_food_menu_option_5_item_1: "Paid",
     home_food_menu_option_5_item_2: "Unpaid",
     home_food_menu_option_6: "Days",

 
    home_food_menu_option_1_item_1: "for 4 days",
    home_food_menu_option_1_item_2: "for 6 days",
    home_food_menu_option_1_item_3: "for 12 days",
    home_food_menu_option_1_item_4: "for 24 days",

    home_food_menu_option_1_item_5: "for 5 days",
    home_food_menu_option_1_item_6: "for 10 days",
    home_food_menu_option_1_item_7: "for 15 days",
    home_food_menu_option_1_item_8: "for 20 days",

    home_food_menu_option_2_item_1: "all servings",
    home_food_menu_option_2_item_2: "Breakfast + Dinner",
    home_food_menu_option_2_item_3: "Breakfast + Evening",
    home_food_menu_option_2_item_4: "Dinner + Snack",
    home_food_menu_option_2_item_5: "Dinner + Evening",
    home_food_menu_option_2_item_6: "Breakfast + Dinner + Evening",

    home_food_menu_price: "Price",
    home_food_menu_price_text_1: "You saved ",
    home_food_menu_price_text_2: "returned to your bonus account",
    home_food_menu_btn: "Checkout",
    /* App */
    home_app_header_1: "iKitchen App",
    home_app_header_2: "Download our app",
    home_app_text_1: "Be always in touch to place an order, make changes, get acquainted with the composition of dishes and calories, and also leave your review.",
    home_app_text_2: "Download our app",
    home_map_header: "Delivery map",
    home_reviews_header: "Our clients",
    home_faqs_header: "FAQ",
    home_inst_header_1: "Instagram",
    home_inst_header_2: "What our clients say about our food",
    /* plansPage */
    plans_alert_pay_1: "You will need to pay extra",
    plans_alert_pay_2: "to the courier for the dish",
    plans_alert_save_err: "It is not possible to save without specifying the street and building code",
    plans_alert_error: "Update failed",
    plans_transfer_title: "Transferring the program",
    plans_transfer_title_description: "Select a new start day for the program",
    plans_pay_title_paid: "Surcharge",
    plans_pay_subtitle_paid: "Supplement for changing a dish in the program",
    plans_not_paid: "Unpaid",
    plans_not_paid_from: "from",
    plans_not_paid_for: "till",
    plans_header: "Profile iKitchen",
    plans_title: "Active plans",
    plans_prolongation_title: "Auto plan renewal",
    plans_prolongation_btn: "Renewal", 
    plans_li_1: "Menu",
    plans_li_2: "Delivery",
    plans_li_3: "Reviews",
    plans_info: "On days marked with this icon, you can further customize the menu.",
    plans_kkal: "Cal",
    plans_summary_in: "Total in",
    plans_B: "Protein",
    plans_J: "Fat",
    plans_U: "Carbs",
    plans_drink: "drink",
    plans_currency: "CZK",
    plans_gramm: "g",
    plans_dinner: "Breakfast",
    plans_text: "Photos of dishes on the site are an option for serving dishes. The appearance of the dish may differ from the photos on the site.",
    plans_empty_orders: "You have an empty basket yet",
    plans_btn_go_to_menu: "Go to the menu",
    /*ProfilePage*/
    profile_header: "Profile IKitchen ",
    profile_my_data: "My Details",
    profile_second_name: "Surname",
    profile_name: "Name",
    profile_organization_name: "The name of the company",
    profile_INN: "Company Registration No.",
    profile_entity_adress: "Legal Address",
    profile_email: "E-mail",
    profile_change_pass: "Change Password",
    profile_old_pass: "Old Password",
    profile_new_pass: "New Password",
    profile_again_pass: "Confirm Password",
    profile_pass_6_symbol: "at least 6 characters",
    profile_again_pass_wrong: "* Passwords do not match",
    profile_delivery_info: "Delivery Information",
    profile_info_task: "To place an order, you need to add delivery information.",
    profile_phone: "Contact number",
    profile_street: "Street, house",
    profile_city: "City",
    profile_index: "Postal code",
    profile_commentary: "Comment",
    profile_dop_info: "Additional delivery information (apartment number, other commentary for the courier)",
    profile_btn_save: "Save",
    profile_agreement: "Processing of personal data agreement",
    profile_btn_exit: "Exit",
    /*SubscribePage*/
    subscribe_alert: "To subscribe, contact the manager",
    subscribe_header: " Profile IKitchen ",
    subscribe_question: "What does the subscription give to me?",
    subscribe_my_subscribe: "My subscription",
    subscribe_miss: "You do not have an active subscription. To subscribe, attach the card below",
    subscribe_btn_subscribe_deal: "Attach subscription",
    subscribe_card_info: "Card Information",
    subscribe_card_num: "Card number",
    subscribe_btn_change_card: "Change card",
    subscribe_discount_info: "You have a discount ",
    subscribe_info_1: "Ordering a program for 12 days, 18 days or a month",
    subscribe_info_2: "Discount x% CZK when paying immediately",
    subscribe_info_3: "The ability to pay for the program immediately in full",
    subscribe_info_4: "Or pay a monthly subscription once a week on a specific day",
    subscribe_faq_header: "How does the subscription work?",
    subscribe_faq_text_1: "How many days can I sign up for? ",
    subscribe_faq_text_2: "12 days, 18 days or a month",
    subscribe_faq_text_3: "How do I pay for a subscription?",
    subscribe_faq_text_4: "By card through the payment system",
    subscribe_faq_text_5: "How is the charge charged?",
    subscribe_faq_text_6: "Once a week (on Saturday / Sunday before the start of a new week of the program), funds are automatically debited from the card.",
    subscribe_faq_text_7: "What if there is no money on the card?",
    subscribe_faq_text_8: "If the charge-off did not work on Saturday, the courier will ask for payment of the order on delivery on Sunday through his payment terminal, or request payment in cash.",
    /*UI Module*/
    //uibasketcard
    basketcard_text_1: "Text description",
    basketcard_text_2: "Breakfast + Lunch, on 14 days",
    basketcard_currency: "CZK",
    //UiCalculator
    calculator_gender: "Sex",
    calculator_woman: "Female",
    calculator_man: "Male",
    calculator_age: "Age",
    calculator_height: " Height",
    calculator_sm: "cm",
    calculator_weight: "Weight",
    calculator_kg: "kg",
    calculator_back_step: "Back",
    calculator_next_step: "Next step",
    calculator_done: "Done",
    calculator_header_1: "Your activity",
    calculator_li_1_item_1: "Passive lifestyle",
    calculator_li_1_item_2: "Low sport activity (1-2x per week) ",
    calculator_li_1_item_3: "High sport activity (3-5x per week)",
    calculator_li_1_item_4: "Professional sport",
    calculator_header_2: "Food preferences",
    calculator_li_2_item_1: "Balanced food",
    calculator_li_2_item_2: "Vege",
    calculator_li_2_item_3: "hypoallergenic (gluten, nuts, lactose, eggs excluded) ",
    calculator_li_2_item_4: "Keto dieta (for fast weight loss)",
    calculator_li_2_item_5: "paleo diet",
    calculator_li_2_item_6: "Anti-age food",
    calculator_li_2_item_7: "increase immunity",
    calculator_header_3: "Your personal goal",
    calculator_li_3_item_1: "Lose weight",
    calculator_li_3_item_2: "Stay fit",
    calculator_li_3_item_3: " Gain",
    //UiDeliveryItem
    delivery_item_delivery: "Portion delivery in",
    delivery_item_day: "morning",
    delivery_item_evening: " evening",
    delivery_item_adress: "Shipping Address",
    delivery_item_btn_change: "Edit",
    delivery_item_wishes: "Comments",
    //UiPlanCard
    plan_card_btn_add: "Add ",
    plan_card_btn_delete: "Delete",
    plan_card_btn_swap: "Replace",
    plan_card_composition: "Nutrition facts",
    plan_card_in_100_gramm: "per serving",
    plan_card_kkal: "Cal",
    plan_card_B: " Protein",
    plan_card_J: " Fat",
    plan_card_U: " Carbs",
    plan_card_btn_pick: "Choose",
    plan_card_currency: "₽",
    //UiRating
    rating_text: "already rated",
    //UiPie
    pie_kkal: "kCal",
    pie_gramm: "g",
    pie_B: "P",
    pie_J: "F",
    pie_U: "C",
    //UiFooter
    footer_logo_text: "iKitchen",
    footer_adress: "Address",
    footer_adress_text_0: "iCatering s.r.o.",
    footer_adress_text_1: "Company ID: 09092684",
    footer_adress_text_2: "VAT No.: CZ09092684",
    footer_adress_text_3: "Evropská 157a, Prague 6",
    footer_adress_text_4: "info@ikitchen.cz",
    footer_phone: "Phone",
    footer_phone_num: "+420 222 744 130",
    footer_brend: "iKitchen",
    footer_ARR: "All Rights Reserved - 2020",
    //UiSwitch
    switch_evening: "in the evening ",
    switch_day: "morning",
    // UiHeader
    header_lang_ru: "Русский",
    header_lang_ch: "Čeština",
    header_lang_en: "English",
    header_about: "About Us",
    header_calc: "Calculator",
    header_faq: "Questions and Answers",
    header_contact: "Contacts",
    header_home: "Home",
    header_profile: "My profile",
    header_basket: "My basket",
    header_plans: "Active plans",
    header_subscribe: "Subscription",
    header_preferences: "My Preferences",
    header_bonus: "Bonuses",
    header_btn_menu: "Menu",
    //UiModalChangeAdress
    modal_change_adress_street: "Street house",
    modal_change_adress_city: "City",
    modal_change_adress_index: "Index",
    modal_change_adress_wishes: "Wishes",
    modal_change_adress_time: "Time",
    modal_change_adress_btn_save: "Save",
    //UiMenuProfile
    menu_profile_profile: "My profile",
    menu_profile_basket: "My basket",
    menu_profile_plans: "Active Plans",
    menu_profile_subscribe: "Subscription",
    menu_profile_preferences: "My Preferences",
    menu_profile_bonus: "Bonuses",
    menu_profile_history: "History",
    // UiModalPay
    modal_pay_on: "on",
    modal_pay_days: "days",
    modal_pay_currency: "CZK",
    modal_pay_bonus: "Available bonuses for payment ",
    modal_pay_pay_bonus: "Pay with bonuses",
    modal_pay_promocode: "Promo Code",
    modal_pay_promocode_not_valid: "Promo code is not valid",
    modal_pay_to_pay: "Total price to pay",
    modal_pay_NDS: "Including VAT",
    modal_pay_pay_card: "Pay by credit card",
    modal_pay_placeholder: "CARDHOLDER NAME",
    modal_pay_cash_to_courier: "Cash on delivery ",
    modal_pay_pay_card_to_courier: "Payment by card to the courier upon delivery",
    modal_pay_bank_transfer: "Bank Transfer",
    modal_pay_btn_pay: "Pay",
    modal_pay_btn_order: "ORDER with obligation to pay",
    //UiTopSlider
    home_slider_title_1: "Healthy meal plan delivery",
    home_slider_text_1: "You get the food you will fall in love with. Food that will improve your health, immune system and get you more energetic and younger.",
    home_slider_title_2: "SHOPPING, PREPARING OR COOKING?",
    home_slider_text_2: "Your schedule is busy enough. We are here to add time back to your life.",
    home_slider_title_3: "Healthy meal plan delivery",
    home_slider_text_3: "You get the food you will fall in love with. Food that will improve your health, immune system and get you more energetic and younger.",
    home_slider_btn_more: "More",
    home_slider_btn_plan: "Choose a plan",
    home_slider_btn_deli: "Map delivery",
    //UiModalMenu
    modal_menu_dinner: "Breakfast",
    modal_menu_kkal: "Cal",
    modal_menu_gramm: "g",
    modal_menu_kkal: "Replace second breakfast on Tuesday",
    //UiFaq
    faq_slimming: "Storage and consumption",
    faq_products: "Food",
    faq_rates: "About Us",
    faq_pay: "Shipping and payment",
    faq_Storage: "Order",
    /*Advantages*/
    faq_0_question_1: "How much time will I save?",
    faq_0_question_2: "Do I need to buy additional products?",
    faq_0_question_3: "What if I get bored with the menu?",
    faq_0_answer_1: "Up to 20 hours per week. And all because you do not need to waste your time on shopping, cooking, calories calculation and washing dishes. Just poke holes in the foil and heat for 2-3 minutes in the microwave. Delicious and healthy food is ready! It is better to spend free time with family, communicate with friends, have fun and self-develop.",
    faq_0_answer_2: "Your refrigerator will be filled to the brim with boxes of healthy and delicious food. Each menu is thought out by the chef and meets nutritional standards.",
    faq_0_answer_3: "We don't repeat ourselves. Every day for 3 weeks you eat something new, but always from your favorite quality and healthy ingredients. We also prepare healthy sweets and desserts. In addition, you can always change the nutrition program and customize the menu to your liking.</br></br>Will I be able to eat iKitchen on the road or take it to work for lunch?</br></br>Our boxes are sealed and compact. They are easy to take with you, they are convenient to eat and use. Hot dishes will remain delicious if they are preheated in the microwave. It is important that for long trips it is necessary to transport food in the refrigerator.",
    /*Food*/
    faq_1_question_1: "What should I do if I have a food allergy?",
    faq_1_question_2: "GLUTEN-FREE",
    faq_1_question_3: "DIARY-FREE (LACTOSE-FREE)",
    faq_1_question_4: "Is your menu really balanced?",
    faq_1_question_5: "What products do you use?",
    faq_1_question_6: "Where can I see the menu?",
    faq_1_answer_1: "If you are allergic to certain products, please select them from the provided list of exceptions during the process of registration (or specify later in your personal profile in the section “exclude from diet”).We will try to exchange these products for others. However, please note that traces of the mentioned products may appear due to their use in our premises for other customers.</br></br>Removal of 1 product from the menu is free of charge, each additional change is charged at the rate of 20 CZK / day. In case of exchanging dairy products for alternatives of plant origin, the surcharge is 40 CZK/day.</br></br>Due to the production reasons we are not able to exclude the products, which are the part of the meals such as  onion, garlic, herbs, tomatoes etc.",
    faq_1_answer_2: "Meals for our healthy meal plans are cooked from gluten-free ingredients.But in the same kitchen we cook other meals containing gluten (for purposes other than the healthy meal plans iKitchen). Everything is thoroughly cleaned after working with gluten. But there may be traces of gluten on some products.",
    faq_1_answer_3: "Each program can be modified to “lactose free” version. In case of exchanging dairy products for alternatives of plant origin, the surcharge is 40 CZK/day.",
    faq_1_answer_4: "We pay great attention to the variety of our dishes, so that you get a truly balanced diet every day. We evaluate not only the calorie content, but also the optimal ratio of nutritional value of products to achieve the best results.Our food is rich in fruits and vegetables to improve your health. We offer healthy desserts without sugar and gluten.",
    faq_1_answer_5: "We use high quality products without artificial colors and preservatives. All of our meals are gluten free. All products are supplied by trusted local suppliers, some products are of bio quality.",
    faq_1_answer_6: "The current menu can be found on our website www.iKitchen.cz. If you register and add a healthy meal plan to your cart, the cart will display a detailed menu for the selected period.</br></br>If you have already purchased the program, you will find its menu with nutritional information in your personal profile, in the 'Active Programs' section.",
    /*About Us*/
    faq_2_question_1: "What kind of programs do you offer?",
    faq_2_answer_1: "<h5><b><u>Balance</u></b></h5> <p>This is a classic program that suits every person.</p> <p>You don't have to give up your favorite foods. We have excluded only harmful dyes, preservatives, sugar and gluten!</p> <p>Balance is a program where you will find all the nutrients you need in the right proportions and quantities. You will find many vegetables and fruits as a source of essential vitamins and minerals to strengthen the immune system.</p> <p><b><em><u>On request, we can adapt this program to lactose-free option.</u></em></b></p> <p><u>The subcategory of the program differs depending on the daily calories intake:</u></p> <p><b>Lose Weight </b>&ndash; 1100-1300 kCal &ndash; 4 meals a day.</p> <p><b>Daily </b>&ndash; 1350-1550 kCal &ndash; 4 meals a day.</p> <p><b>Fit </b>&ndash; 1600-1800 kCal &ndash; 5 meals a day, including a healthy dessert.</p> <p><b>Power </b>&ndash; 1950-2500 kCal &ndash; 5 meals a day, including a healthy dessert.</p> <h5><b><u>Vege</u></b></h5> <p>A balanced vegetarian meal plan is based on the consumption of plant foods, diary products and eggs. In the vege menu you will not find meat, fish and seafood.</p> <p><u>The subcategory of the program differs depending on the daily calories intake:</u></p> <p><b>Lose Weight </b>&ndash; 1100-1300 kCal &ndash; 4 meals a day.</p> <p><b>Daily </b>&ndash; 1350-1550 kCal &ndash; 4 meals a day.</p> <p><b>Fit </b>&ndash; 1600-1800 kCal &ndash; 5 meals a day, including a healthy dessert.</p> <p><b>Power </b>&ndash; 1950-2500 kCal &ndash; 5 meals a day, including a healthy dessert.</p> <h5><b><u>Low Carb</u></b></h5> <p>A Low Carb healthy meal plan contains a limited amount of carbohydrates, a higher content of fats and proteins. Currently, this diet is one of the most effective ways to lose weight. Low Carb will not only improve your figure, but also your mood and will become your lifestyle. Someone will forget about diabetes, and someone will begin to understand their body and finally lose the feeling of eternal hunger.</p> <p><u>The subcategory of the program differs depending on the daily calories intake:</u></p> <p><b>Lose Weight </b>&ndash; 1100-1300 kCal &ndash; 4 meals a day.</p> <p><b>Daily </b>&ndash; 1350-1550 kCal &ndash; 4 meals a day.</p> <p><b>Fit </b>&ndash; 1600-1800 kCal &ndash; 5 meals a day.</p> <p><b>Power </b>&ndash; 1950-2500 kCal &ndash; 5 meals a day.</p> <h5><b><u>Anti-age</u></b></h5> <p>Anti-age is an anti-aging healthy meal plan. It contains no meat, but is rich in vegetables and fruits, fish and seafood, nuts and other products that help prolong youth. We recommend trying this program for one to two months as a way of healing and rejuvenating your body. You will be surprised how your skin and hair will look like afterwards. Your body will get the missing energy.</p> <p><u>The subcategory of the program differs depending on the daily calorie intake:</u></p> <p><b>Lose Weight </b>&ndash; 1100-1300 kCal</p> <p><b>Daily </b>&ndash; 1350-1550 kCal</p> <p><b>Fit </b>&ndash; 1600-1800 kCal</p> <p>The Anti-age program always includes 3 meals a day. According to the rules on which the anti-aging diet is based, there should be longer breaks between meals, and snacking is not recommended.</p> ", 
    /*Shipping and payment*/    
    faq_3_question_1: "How is delivery carried out?",
    faq_3_question_2: "Is it possible to set a different time slot for delivery?",
    faq_3_question_3: "Delivery address change",
    faq_3_question_4: "What if I can't take food?",
    faq_3_question_5: "Is it possible to pause the ordered program for several days?",
    faq_3_question_6: "How much does shipping cost?",
    faq_3_question_7: "How can I pay for an order?",
    faq_3_question_8: "Product exchange",
    faq_3_answer_1: "Delivery is carried out on Sunday, Tuesday, Thursday by courier service from 17:00 to 22:00. On the day of delivery, you will receive an email notification of a more accurate delivery time (2-hour time slot). You always get food for the next 2 days.",
    faq_3_answer_2: "We can adapt within the current possibilities (for example, delivery after 18:00 - 19:00, etc.).Just write down your wish in a comment when placing an order or in your personal account. We will do our best to negotiate with the delivery provider.",
    faq_3_answer_3: "You can set the delivery address in your personal profile in the 'Delivery' section. Each day of delivery may have a different address.<i>It is important that the change of address in the personal profile takes place no later than 48 hours before the day of delivery.</i></br>If you need to change your address later, please inform us in writing by sending an email to info@ikitchen.cz, at least 24 hours in advance (until 16:00 the day before delivery). In exceptional cases, we can change the address on the day of delivery until 12:00. In this case, however, we are not able to guarantee that the carrier accepts the change.",
    faq_3_answer_4: "In the event of force majeure (you are unavailable/did not answer the call/did not ask in advance to leave the food bag on the doorknob or at the reception), the courier will be able to stay at the delivery address for a maximum of 15 minutes. After that, he will be forced to return to the route for the return of the next orders.In this case, the goods will be delivered without a personal transfer, by the so-called 'hanging on the handle', when it is considered that the Buyer accepted the Goods at the time of the impersonal delivery.(for more details, see Terms and Conditions).</br></br>Also, the courier can deliver this product later, by agreement. The surcharge for the service is 200 CZK in cash, directly to the courier. This possibility is a subject to agreement with the delivery person. He has a right to refuse, if the current circumstances do not allow him/her to fulfil the request.",
    faq_3_answer_5: "Yes. We will be happy to make changes if you notify us at least 2 working days before the day of delivery. Please inform us in written by sending an email with your request to info@ikitchen.cz.",
    faq_3_answer_6: "We currently have the following shipping rates:</br>Prague, Prague-East, Prague-West, Kladno - free.</br>Other settlements marked on the delivery map - from 50 to 100 CZK / day, depending on the location.</br>Shipping costs will be charged additionally after confirmation of the order (you will receive an invoice for the full amount including shipping costs by e-mail).</br>The cost of delivery to other locations - outside the delivery card - is specified upon request.",
    faq_3_answer_7: "We offer the possibility of paying by credit card online, by card upon receipt, by bank transfer. </br> </br><b>Payment online by credit card.</b> </br>After creating the order, you will be redirected to the bank's secure payment gateway, where you will enter the necessary data. If the transaction is authorized, payment will be made immediately. We support the 3D Secure protocol. Our staff does not have access to your card details, everything is only in the hands of the bank. </br> </br><b>Bank transfer.</b> </br>After completing your order, you will receive a confirmation email with payment instructions. </br> </br><b>Payment on receipt.</b> </br>If you choose payment upon receipt, it is necessary to pay the total amount for the ordered program to the courier upon the first delivery. We prefer payment by card, in exceptional cases cash payment is also possible. </br>We are currently working on this principle in order to avoid paying in cash for hygienic reasons. Thank you in advance for your understanding. ", 
    faq_3_answer_8: "The exchange of each product is charged in the amount - 10-20 CZK / one product / day. Exchange of dairy products - 40 CZK / day. The exact price is given for the specific product in the list when ordering.",
    /*Order*/
    faq_4_question_1: "How long in advance should I place an order?",
    faq_4_question_2: "How can I order?",
    faq_4_answer_1: "3 days before the start of the program. </br>To start the program from Monday - send the order no later than on Friday at 23:59. </br>To start the program from Wednesday - send the order no later than on Sunday at 23:59. </br>To start the program from Friday - send the order no later than on Tuesday at 23:59. ",
    faq_4_answer_2: "Place your order on the website www.iKitchen.cz. </br>To do this, you need to select a program, the number of days and portions. To place an order, you need to fill in the registration data. By registering, you will receive a personal profile where you will find an active meal plan, including menu and nutritional information. </br> </br>If you have any problems with placing an order, just send us the information to the email address info@iKitchen.cz - we will help with the registration and then send the access data to your personal profile (you may change them anytime later). </br>Required data for registration: name and surname, delivery address and contact phone number, e-mail address, selected program and number of days.",
    /*Storage and consumption*/
    faq_5_question_1: "How should the food boxes be stored?",
    faq_5_question_2: "How the food should be heated?",
    faq_5_answer_1: "The product is delivered chilled. Prior to use, the goods should be stored in a cool place at a temperature of 2-4 ° C.",
    faq_5_answer_2: "Some of our dishes are eaten cold (like salads, jogurts, desserts etc.). Hot meals are heated in the microwave. Make holes in the foil and heat for 2-3 minutes at 600-700 watts.",
}